<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Heizung</h2>
      <p class="step-text">Beheizen Sie Ihre Wohnung mit einer Wärmepumpe?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Wärmepumpe vorhanden"
          @click="setHeatpump('yes')"
          :iconDefault="require('@/assets/icons/Svgs/Waermepumpe.svg')"
          :iconHover="require('@/assets/icons/Svgs/Waermepumpe_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Keine Wärmepumpe vorhanden"
          @click="setHeatpump('no')"
          :iconDefault="require('@/assets/icons/Svgs/not-existent.svg')"
          :iconHover="require('@/assets/icons/Svgs/not-existent_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import {
  saveToStorage,
} from "@/utils.js";
export default {
  name: "wohnung-step-5",
  components: {
    ActionBox
  },
  data() {
    return {
      fields: {
        heatpump: { value: null },
      },
    };
  },
  methods: {
    setHeatpump(index) {
      this.fields.heatpump.value = index;
      saveToStorage(this.fields);
      this.$router.push("/wohnung-step-6");    },
    goBack() {
        this.$router.push("/wohnung-step-4");
    },

  },
  mounted() {
    this.$emit("setStep", "wohnung", 6);
  },
};
</script>
